import React, { Component } from 'react';
import  ReactDOM from 'react-dom'

import  "./bbutil"
import BBIFrame from './BBIFrame';

class BBMap extends BBIFrame {

 

  getUrl()
  {
     BBIFrame.scrolling="no";
    return "/bb/map/leafletWidgetDeploy.html";
  }


  
}
export default BBMap; 